
import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';


@Component({
  selector: 'pms-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit{

  isSidebarOpen = true;
  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }
  constructor() { }

  ngOnInit(): void {
  }
}